/* eslint-disable */
import React from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { useAppState } from '@nutastic/nutastic-react-app';
import ContentMusicPage from './ContentMusicPage';
import ContentVideoPage from './ContentVideoPage';
import ListPage from './ListPage';
import ModalPageContainer from '../ModalPageContainer';
import { useNavigation } from '../../hooks/useNavigation';
import ShopListPage from './ShopListPage';
import ShopProductPage from './ShopProductPage';
import LoadingOverlay from '../LoadingOverlay';
import { CONSTANTS } from '../../utils/constants';
import ContentNewsPage from "./ContentNewsPage";

const VALID_CONTENT_TYPES = [CONSTANTS.APPKEY_AUDIO_SERIES, CONSTANTS.APPKEY_VIDEO, CONSTANTS.APPKEY_NEWS];
const VALID_CONTENT_PATHS = [ '/shop/', '/keys/'];

const ContentPage = () => {
    const { isProcessing } = useAppState();
    const { contentType } = useParams();
    const { loadPage } = useNavigation();
    const windowPath = window.location.pathname;
    const isValidPagePath = windowPath.endsWith('/shop') || !!VALID_CONTENT_PATHS.find(validPath => windowPath.includes(validPath));
    const shouldShowModal = VALID_CONTENT_TYPES.includes(contentType) || isValidPagePath;

    const onCloseClick = () => {
        loadPage('/');
    };

    return <ModalPageContainer isActive={shouldShowModal} onClose={onCloseClick}>
        { isProcessing && <LoadingOverlay /> }
        <Switch>
            <Route path={"/keys/:id?"} component={ListPage} />
            <Route path={`/content/${CONSTANTS.APPKEY_AUDIO_SERIES}/:id`} component={ContentMusicPage} />
            <Route path={`/content/${CONSTANTS.APPKEY_VIDEO}/:id`} component={ContentVideoPage} />
            <Route path={`/content/${CONSTANTS.APPKEY_NEWS}/:id`} component={ContentNewsPage} />
            <Route path={"/shop"} exact={true} component={ShopListPage} />
            <Route path={"/shop/:id"} component={ShopProductPage} />
        </Switch>
    </ModalPageContainer>
};

export default ContentPage;
